/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Month_JanuaryInputs */

const he_month_january = /** @type {(inputs: Month_JanuaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ינואר`)
};

const en_month_january = /** @type {(inputs: Month_JanuaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`January`)
};

/**
* | output |
* | --- |
* | "January" |
*
* @param {Month_JanuaryInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const month_january = /** @type {((inputs?: Month_JanuaryInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Month_JanuaryInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_month_january(inputs)
	return en_month_january(inputs)
});